export default "__VITE_ASSET__66f6ae91__"